import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { RouterModule } from '@angular/router'

import type { AccentColors } from '@app/models/ui'
import { AddNextPrefixPipe } from '@app/modules/navigation/pipes/add-next-prefix.pipe'
import type { Notification, NotificationType } from '@app/modules/notifications'
import { ActivityStatusBadgeComponent } from '@app/modules/profile/components/activity-status-badge/activity-status-badge.component'
import type { IconSymbol } from '@app/modules/ui/components/icon/icon.model'
import { UIModule } from '@app/modules/ui/ui.module'
import { MemberService } from '@app/services/member.service'

import { Closeable } from '../closeable'
import { ModalService } from '../modal/modal.service'

type IconMap = Record<NotificationType, NotificationIcon>

interface NotificationIcon {
  icon: IconSymbol
  colorClass: string
  secondaryColor?: AccentColors
}

@Component({
  selector: 'sb-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, ActivityStatusBadgeComponent, AddNextPrefixPipe, UIModule],
})
export class NotificationComponent extends Closeable {
  readonly memberService = inject(MemberService)

  private readonly modalService = inject(ModalService)
  private static readonly headlineIconMap: IconMap = {
    favorite_added: { icon: 'heart', colorClass: 'color-salmon' },
    thread_created: { icon: 'message-bubble', colorClass: 'color-blue', secondaryColor: 'transparent' },
    thread_updated: { icon: 'message-bubble', colorClass: 'color-blue', secondaryColor: 'transparent' },
    message_photo_sent: { icon: 'picture', colorClass: 'color-blue' },
    profile_viewed: { icon: 'visible', colorClass: 'color-black' },
    photo_access_requested: { icon: 'lock', colorClass: 'color-gold' },
    photo_access_granted: { icon: 'check-circle', colorClass: 'color-green' },
    voice_message_sent: { icon: 'mic-on-fill', colorClass: 'color-blue' },
  }

  notification!: Notification

  get headlineIcon(): NotificationIcon | null {
    return NotificationComponent.headlineIconMap[this.notification.note_type]
  }

  onClick(): void {
    this.modalService.closeAll()
    this.close()
  }
}
